import { FC} from "react";
import { StatisticsObjectType } from "../caseVolumeLineChart/types";


const CustomComponentEnrollment: FC<StatisticsObjectType> = ({ StatisticsObjectType }): JSX.Element => {
  return (
    <div className="table-responsive">
      <table className="table table-sm table-responsive overflow-y-auto">
        <thead className="table-light sticky-top">
          <tr className="text-center">
            <th>Practice</th>
            <th>Received</th>
            <th>Active</th>
          </tr>
        </thead>
        <tbody>
          {StatisticsObjectType.enrollments && StatisticsObjectType.enrollments.length > 0 ?
            StatisticsObjectType.enrollments.map((item, key) => (
              <tr className="text-center" key={key}>
                <td>{item.practice_name}</td>
                <td>{item.received}</td>
                <td>{item.active ? 'Accepted' : 'Rejected'}</td>
              </tr>
            ))
            : null
          }
        </tbody>
      </table>
    </div>
  );
};

export default CustomComponentEnrollment;
